// @flow
import queryString from 'query-string';
import axios from 'axios';

const requestCache = {};

export default function templateRequest(requestPathTemplate?: ?string) {
  if (!requestPathTemplate) return Promise.reject();
  let requestPath = requestPathTemplate;
  if (requestPathTemplate.indexOf('{') !== -1) {
    const searchParams = queryString.parse(window.location.search);
    let allRequiredMatches = true;
    requestPath = requestPath.replace(
      /{{\??([a-zA-Z0-9-_]+)}}/gi,
      (match, paramKey) => {
        const queryValue = searchParams[paramKey];
        if (!queryValue && match.indexOf('?') !== 0) {
          allRequiredMatches = false;
        }
        return queryValue;
      }
    );
    if (!allRequiredMatches) {
      return Promise.reject();
    }
  }
  requestCache[requestPath] =
    requestCache[requestPath] || axios.get(`${CONFIG.dinerApi}${requestPath}`);

  return requestCache[requestPath];
}
